import { render, staticRenderFns } from "./TwitterIcon.vue?vue&type=template&id=28032340&"
import script from "./TwitterIcon.vue?vue&type=script&lang=ts&"
export * from "./TwitterIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports